import React, { useState } from 'react';
import { useLibrary } from '../context/LibraryContext';

const heartPopKeyframes = `
@keyframes heartPop {
  0% { transform: scale(1); }
  30% { transform: scale(1.5); }
  60% { transform: scale(0.9); }
  100% { transform: scale(1); }
}
`;

// Inject keyframes once
if (typeof document !== 'undefined' && !document.getElementById('heartpop-style')) {
  const style = document.createElement('style');
  style.id = 'heartpop-style';
  style.textContent = heartPopKeyframes;
  document.head.appendChild(style);
}

function BookmarkButton({ book, size = 'md' }) {
  const { toggleBookmark, isBookmarked } = useLibrary();
  const [animating, setAnimating] = useState(false);

  if (!book) return null;

  const bookmarked = isBookmarked(book.id);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleBookmark(book);
    setAnimating(true);
    setTimeout(() => setAnimating(false), 400);
  };

  const isSmall = size === 'sm';

  const buttonSize = isSmall
    ? 'w-8 h-8'
    : 'w-11 h-11';

  const iconSize = isSmall ? 'w-4 h-4' : 'w-5 h-5';

  const baseStyle = {
    animation: animating ? 'heartPop 0.4s ease' : 'none',
    transition: 'color 0.2s ease, background-color 0.2s ease',
  };

  return (
    <button
      onClick={handleClick}
      aria-label={bookmarked ? 'Remove from bookmarks' : 'Add to bookmarks'}
      title={bookmarked ? 'Remove from bookmarks' : 'Save to library'}
      className={`
        ${buttonSize}
        flex items-center justify-center
        rounded-full
        ${bookmarked
          ? 'bg-accent/20 text-accent hover:bg-accent/30'
          : 'bg-black/40 text-gray-400 hover:text-white hover:bg-black/60'
        }
        backdrop-blur-sm
        transition-all duration-200
        focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-1
        focus:ring-offset-transparent
      `}
      style={baseStyle}
    >
      {bookmarked ? (
        // Filled heart
        <svg
          className={iconSize}
          viewBox="0 0 24 24"
          fill="currentColor"
          style={{ color: '#e94560' }}
        >
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
        </svg>
      ) : (
        // Outline heart
        <svg
          className={iconSize}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
      )}
    </button>
  );
}

export default BookmarkButton;
